import { render } from "./RoomPlayers.vue?vue&type=template&id=7ad54c44&scoped=true"
import script from "./RoomPlayers.vue?vue&type=script&lang=js"
export * from "./RoomPlayers.vue?vue&type=script&lang=js"

import "./RoomPlayers.vue?vue&type=style&index=0&id=7ad54c44&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad54c44"]])

export default __exports__